import React from "react";
import { Box, Button, Typography, Skeleton, useMediaQuery, useTheme } from "@mui/material";

import ComingSoon from "../../../assets/imgs/coming_soon.png";
import { round } from "lodash";
import { useGetWeddingInvitationsQuery } from "../../../store/services/invitations/invitations.service";
import { formatCurrency } from "../../../utils/formatCurrency";
import { Link } from "react-router-dom";
import { trackEvent } from "../../../utils/analytics";
import { getDiscountAmount, getInvitationPrice, getStartPrice } from "../../../utils/getInvitationPrice";
import { trackMetaEvent } from "../../../utils/metaPixel";
import { trackTikTokEvent } from "../../../utils/tiktokPixel";

const WeddingList = () => {
	const { data, isLoading } = useGetWeddingInvitationsQuery({});

	const theme = useTheme();
	const isSmallerScreen = useMediaQuery(theme.breakpoints.down("md"));
	const { invitations } = data || {};

	if (isLoading) {
		const loadingArray = new Array(6).fill(0);
		return (
			<Box display="flex" style={{ flexFlow: "row wrap" }} gap={2}>
				{loadingArray.map((_, index) => (
					<Box key={index} width={isSmallerScreen ? "100%" : "280px"}>
						<Skeleton variant={"rectangular"} height={"290px"} />
						<Skeleton variant={"text"} sx={{ fontSize: "40px" }} />
						<Skeleton variant={"text"} />
					</Box>
				))}
			</Box>
		);
	}
	return (
		<Box className={"templates_list"}>
			{invitations?.map(t => {
				const startPrice = getStartPrice(t.pricing);
				return (
					<Link
						key={t._id}
						to={`/weddingInvitation/${t._id}`}
						style={{
							display: "flex",
							justifyContent: "center",
							textDecoration: "none",
							color: "inherit",
							...(t.is_coming_soon ? { pointerEvents: "none" } : null)
						}}
						onClick={e => {
							trackEvent(`template_${t.name}`, {
								scope: "Invitations templates",
								description: "open Invitation template"
							});
							trackMetaEvent("ViewContent", { name: t.name, id: t._id });
							trackTikTokEvent("ViewContent", {
								content_id: t._id,
								content_type: "product",
								content_name: t.name
							});
							t.is_coming_soon && e.preventDefault();
						}}
						className={"template"}
					>
						{/*{!!startPrice.discount && !t.is_coming_soon && (*/}
						{/*	<Box className={"discount"}>*/}
						{/*		<Typography variant={"subtitle1"}>*/}
						{/*			Save{" "}*/}
						{/*			{startPrice.is_discount_percentage*/}
						{/*				? `${startPrice.discount}%`*/}
						{/*				: `${formatCurrency(startPrice.discount, startPrice.currency)}`}*/}
						{/*		</Typography>*/}
						{/*	</Box>*/}
						{/*)}*/}
						{t.is_coming_soon && (
							<Box className={"coming_soon_over_lay"}>
								<img src={ComingSoon} alt="comming soon" />
							</Box>
						)}

						<img src={t.thumbnail_01} alt="template" className={"thumbnail"} />
						<Box mt={1} mx={1}>
							<Typography variant={"h6"} fontSize={16}>
								{t.name}
							</Typography>
						</Box>
						{/*<Box mx={1} mt={2} display={"flex"} alignItems={"center"} width={"100%"} position={"relative"}>*/}
						{/*	{startPrice.discount ? (*/}
						{/*		<>*/}
						{/*			<Typography variant={"subtitle1"} className={"price"}>*/}
						{/*				{formatCurrency(*/}
						{/*					getInvitationPrice(startPrice.amount, startPrice.is_discount_percentage, startPrice.discount),*/}
						{/*					startPrice.currency*/}
						{/*				)}*/}
						{/*			</Typography>*/}
						{/*			<Typography variant={"subtitle2"} className={"old_price"}>*/}
						{/*				{formatCurrency(round(startPrice.amount, 2), startPrice.currency)}*/}
						{/*			</Typography>*/}
						{/*			<Typography variant={"subtitle2"} className={"off_amount"}>*/}
						{/*				{getDiscountAmount(startPrice.discount, startPrice.currency, startPrice.is_discount_percentage)} OFF*/}
						{/*			</Typography>*/}
						{/*		</>*/}
						{/*	) : (*/}
						{/*		<Typography variant={"subtitle1"} className={"price"}>*/}
						{/*			{formatCurrency(round(startPrice.amount, 2), startPrice.currency)}*/}
						{/*		</Typography>*/}
						{/*	)}*/}
						{/*</Box>*/}
						<Box width={"100%"} mt={2}>
							<Button fullWidth variant={"outlined"} color={"primary"}>
								Preview
							</Button>
						</Box>
					</Link>
				);
			})}
		</Box>
	);
};

export default WeddingList;
